function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInsightsGroupUtils = exports.TakingBigStepsSvg = exports.SaveWaterSvg = exports.SaveMoneySvg = exports.ProtectNatureSvg = exports.FindQuickWinsSvg = exports.EatSustainablySvg = exports.CutCarbonSvg = exports.CutBackOnPlasticSvg = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _locales = require("../../locales");
var _reactI18next = require("react-i18next");
var _components = require("../../components");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var TakingBigStepsSvg = exports.TakingBigStepsSvg = (0, _react.memo)(function (_ref) {
  var props = Object.assign({}, ((0, _objectDestructuringEmpty2["default"])(_ref), _ref));
  return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
    image: require("../../images/Goals/TakingBigSteps.svg")
  }, props));
});
var CutCarbonSvg = exports.CutCarbonSvg = (0, _react.memo)(function (_ref2) {
  var props = Object.assign({}, ((0, _objectDestructuringEmpty2["default"])(_ref2), _ref2));
  return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
    image: require("../../images/Goals/CutCarbon.svg")
  }, props));
});
var SaveMoneySvg = exports.SaveMoneySvg = (0, _react.memo)(function (_ref3) {
  var props = Object.assign({}, ((0, _objectDestructuringEmpty2["default"])(_ref3), _ref3));
  return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
    image: require("../../images/Goals/SaveMoney.svg")
  }, props));
});
var EatSustainablySvg = exports.EatSustainablySvg = (0, _react.memo)(function (_ref4) {
  var props = Object.assign({}, ((0, _objectDestructuringEmpty2["default"])(_ref4), _ref4));
  return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
    image: require("../../images/Goals/EatSustainably.svg")
  }, props));
});
var FindQuickWinsSvg = exports.FindQuickWinsSvg = (0, _react.memo)(function (_ref5) {
  var props = Object.assign({}, ((0, _objectDestructuringEmpty2["default"])(_ref5), _ref5));
  return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
    image: require("../../images/Goals/FindQuickWins.svg")
  }, props));
});
var ProtectNatureSvg = exports.ProtectNatureSvg = (0, _react.memo)(function (_ref6) {
  var props = Object.assign({}, ((0, _objectDestructuringEmpty2["default"])(_ref6), _ref6));
  return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
    image: require("../../images/Goals/ProtectNature.svg")
  }, props));
});
var CutBackOnPlasticSvg = exports.CutBackOnPlasticSvg = (0, _react.memo)(function (_ref7) {
  var props = Object.assign({}, ((0, _objectDestructuringEmpty2["default"])(_ref7), _ref7));
  return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
    image: require("../../images/Goals/CutBackOnPlastic.svg")
  }, props));
});
var SaveWaterSvg = exports.SaveWaterSvg = (0, _react.memo)(function (_ref8) {
  var props = Object.assign({}, ((0, _objectDestructuringEmpty2["default"])(_ref8), _ref8));
  return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
    image: require("../../images/Goals/SaveWater.svg")
  }, props));
});
var useInsightsGroupUtils = exports.useInsightsGroupUtils = function useInsightsGroupUtils() {
  (0, _locales.useFootprintLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var addSubLabels = function addSubLabels(footprints) {
    return footprints.map(function (footprint) {
      return Object.assign({}, footprint, {
        id: footprint.id || '',
        value: Number((footprint.g_co2e / 1000).toFixed(0)),
        label: t("footprint:item.".concat(footprint.id))
      });
    });
  };
  var formatFootprints = function formatFootprints(footprintSections) {
    if (!footprintSections) return [];
    return footprintSections.map(function (section) {
      return Object.assign({}, section, {
        value: Number((section.g_co2e / 1000).toFixed(0)),
        label: t("footprint:category.".concat(section.id)),
        footprints: addSubLabels(section.footprints)
      });
    });
  };
  var updateFootprintData = function updateFootprintData(data) {
    if (!data) return [];
    return data.map(function (item) {
      return Object.assign({}, item, {
        unit: 'kg',
        footprints: item.footprints ? updateFootprintData(item.footprints) : []
      });
    });
  };
  var formatImpacts = function formatImpacts(impactSections) {
    if (!impactSections) return [];
    return impactSections.map(function (section) {
      return Object.assign({}, section, {
        label: section.name
      });
    });
  };
  var updateImpactData = function updateImpactData(data) {
    if (!data) return [];
    return data.map(function (item) {
      return Object.assign({}, item, {
        unit: item.value === 1 ? ' step' : ' steps'
      });
    });
  };
  var goalToSvgMap = {
    cut_carbon: CutCarbonSvg,
    save_money: SaveMoneySvg,
    eat_sustainably: EatSustainablySvg,
    find_quick_wins: FindQuickWinsSvg,
    cut_back_on_plastic: CutBackOnPlasticSvg,
    take_big_impact_steps: TakingBigStepsSvg,
    protect_nature: ProtectNatureSvg,
    save_water: SaveWaterSvg
  };
  return {
    addSubLabels: addSubLabels,
    formatFootprints: formatFootprints,
    formatImpacts: formatImpacts,
    updateFootprintData: updateFootprintData,
    updateImpactData: updateImpactData,
    goalToSvgMap: goalToSvgMap
  };
};